// extracted by mini-css-extract-plugin
module.exports = {"row":"Breadcrumbs_row__p0MXk","item":"Breadcrumbs_item__2U0sw","itemText":"Breadcrumbs_itemText__7QBMA"};